import { parseToDateTime } from '@calendly/datetime'
import { boolean, number, object, string } from '@calendly/form/validation'
import { I18n } from '@calendly/i18n'

export const parseAndFormatDate = (dateString) => {
  const date = parseToDateTime(dateString)
  return date?.isValid ? date : null
}

export const buildValidationSchema = () => object({
  name: string()
    .trim()
    .required(I18n.t('errors.messages.blank'))
    .min(5, I18n.t('errors.messages.too_short', { count: 5 }))
    .max(64, I18n.t('errors.messages.too_long', { count: 64 })),
  code: string()
    .trim()
    .required(I18n.t('errors.messages.blank'))
    .min(3, I18n.t('errors.messages.too_short', { count: 3 }))
    .max(64, I18n.t('errors.messages.too_long', { count: 64 })),
  type: string()
    .oneOf(['percentage', 'fixed'])
    .required(I18n.t('errors.messages.blank')),
  amount: number()
    .typeError(I18n.t('errors.messages.not_a_number'))
    .required(I18n.t('errors.messages.blank'))
    .when('type', {
      is: 'percentage',
      then: (schema) => schema
        .min(1, I18n.t('errors.messages.greater_than_or_equal_to', { count: 1 }))
        .max(100, I18n.t('errors.messages.less_than_or_equal_to', { count: 100 }))
        .integer(I18n.t('errors.messages.not_an_integer')),
      otherwise: (schema) => schema
        .min(0.01, I18n.t('errors.messages.greater_than_or_equal_to', { count: 0.01 }))
        .max(100000, I18n.t('errors.messages.less_than_or_equal_to', { count: 100000 }))
    }),
  firstTimeOnly: boolean(),
  limitUsage: boolean(),
  usageLimit: number()
    .when('limitUsage', {
      is: true,
      then: (schema) => schema
        .typeError(I18n.t('errors.messages.not_a_number'))
        .required(I18n.t('errors.messages.blank'))
        .min(1, I18n.t('errors.messages.greater_than_or_equal_to', { count: 1 }))
        .max(1000000, I18n.t('errors.messages.less_than_or_equal_to', { count: 1000000 }))
        .integer(I18n.t('errors.messages.not_an_integer')),
      otherwise: (schema) => schema.optional()
    }),
  addExpiration: boolean(),
  expirationTime: string()
    .when('addExpiration', {
      is: true,
      then: (schema) => schema.required(I18n.t('errors.messages.blank')),
      otherwise: (schema) => schema.optional()
    }),
  expirationDate: string()
    .when('addExpiration', {
      is: true,
      then: (schema) => schema.required(I18n.t('errors.messages.blank')),
      otherwise: (schema) => schema.optional()
    })
})
